import { Map } from 'immutable';

export const defaultCallData = new Map({
  n: 'Image_query',
  METADATA: 'TOMBSTONE',
  START: 1,
  ORIGINAL_URLS: 'TRUE',
  IS_ADVANCED: 'FALSE',
  INCLUDE_MASTER_METADATA: 'TRUE',
  SHOW_MASTER_METADATA: 'TRUE',
  FORCE_REFRESH: 'TRUE',
});

export const errorMessages = {
  INVALID_ARGS_PAGE: 'Invalid argument; requires page number',
  INVALID_ARGS_PAGE_RANGE: 'Invalid argument; page number is not within range',
  NO_SEARCHPARAMS: 'No search parameters defined',
};

export const viewTypes = {
  GRID: 'GRID',
  GRID_NOJ: 'GRID_NOJ',
  LIST: 'LIST',
  SM_GRID_NOJ: 'SM_GRID_NOJ',
};

export const searchExistsMessage = 'Query with this name already exists';

export const defaultWorkspaceMenu = ['removeFromWorkspace', 'exportXLS', 'exportPPT', 'exportZIP', 'exportToPDF',
  'saveToDropbox', 'usageBasket', 'photoBasket', 'email', 'relateUMOs', 'shareAsPortal', 'resizeAll'];



// WEBPACK FOOTER //
// ./src/js/constants/umoGallery.js